import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Nom016InformacionGeneral() {
  return <CategoryPage category="nom016InformacionGeneral" pageTitle="Información General" />;
}

export default Nom016InformacionGeneral;
